import { Link } from 'react-router-dom'

import { getInitials } from '@/utils/activity'

type UserIdentityProps = {
  userId: string
  orgId?: string
  name?: string | null
  email?: string | null
  /** link the name to the user details page */
  href?: string
}

/** Who a user activity view is about: initials, name, email, ids. */
export const UserIdentity = ({
  userId,
  orgId,
  name,
  email,
  href
}: UserIdentityProps) => {
  const label = name || email || 'Unknown user'

  return (
    <div className="flex items-center gap-4">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-secondary/20 text-base font-semibold text-secondary">
        {getInitials(name, email)}
      </div>
      <div className="min-w-0 space-y-0.5">
        <h2 className="truncate text-lg font-semibold">
          {href ? (
            <Link className="underline-offset-4 hover:underline" to={href}>
              {label}
            </Link>
          ) : (
            label
          )}
        </h2>
        <p className="truncate text-sm text-muted-foreground/80">
          {email || '—'}
        </p>
        <p className="font-mono text-xs text-muted-foreground/70">
          User ID {userId}
          {orgId ? ` · Org ${orgId}` : ''}
        </p>
      </div>
    </div>
  )
}
